/**
 * Automatically adjusts the height of all textareas on the page based on their content.
 * @function
 * @returns {void}
 */
export function autosizeTextareas() {
    const textareas = document.querySelectorAll("textarea");

    if (textareas) {
        textareas.forEach((area) => {
            area.addEventListener("input", OnInput, false);
            adjustTextareaHeight(area);
        });

        function OnInput() {
            adjustTextareaHeight(this);
        }

        function adjustTextareaHeight(textarea) {
            const scrollLeft =
                window.scrollX || document.documentElement.scrollLeft;
            const scrollTop =
                window.scrollY || document.documentElement.scrollTop;

            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";

            window.scrollTo(scrollLeft, scrollTop);
        }
    }
}
